import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../utilities/TabGrid";


export default class OdKierowcowTable extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };

    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextprops){
    }


    render() {

        const options = {
            sizePerPage: 15,  // Showing 30 for the size per page as default
            sizePerPageList: [10, 15, 30],
            noDataText: 'Brak pasujących rekordów'
        };

        return (
            <div>
                <div>
                    <div className={'pull-right'} style={{fontSize: '12px', color: 'grey', padding: '5px', fontStyle: 'italic'}}>
                        Ilość wyszukanych wiadomości: {Boolean(this.props.data) ? this.props.data.length : 0}
                    </div>
                </div>
                <div>
                    <BootstrapTable data={this.props.data}
                                    options={options}
                                    pagination
                                    hover
                    >
                        <TableHeaderColumn dataField='idPowiadomienia' isKey dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}

                        >ID</TableHeaderColumn>
                        <TableHeaderColumn dataField='dataWpisu' dataSort
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}

                        >Data i godzina</TableHeaderColumn>
                        <TableHeaderColumn dataField='tytul' dataSort
                                           thStyle={tabgrid.tg8} tdStyle={tabgrid.tg8}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}

                        >Tytuł</TableHeaderColumn>
                        <TableHeaderColumn dataField='tresc' dataSort
                                           thStyle={tabgrid.tg12} tdStyle={tabgrid.tg12}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}

                        >Treść</TableHeaderColumn>
                    </BootstrapTable>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/komunikaty/powiadomienia/components/odkierowcowComponents/OdKierowcowTable.js